export default __webpack_public_path__ + "static/media/index-background.8aab1ab5.svg";